export default __webpack_public_path__ + "static/media/People.bc672e0d.jpg";